import React, { useState, useEffect } from "react";
import CleanupsColl from "../firebase/CleanupsColl";
import UtilDate from "../util/UtilDate";
import LoadingSpinner from "./LoadingSpinner";

const RecentCleanupsFeed = () => {
  const [recentCleanups, setRecentCleanups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecentCleanups = async () => {
      try {
        // Get date from 7 days ago
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

        const cleanups = await CleanupsColl.shared.getCleanupsFromDate(
          oneWeekAgo
        );

        if (cleanups && cleanups.length > 0) {
          // Limit to 10 most recent cleanups
          const limitedCleanups = cleanups.slice(0, 10);
          setRecentCleanups(limitedCleanups);
        } else {
          setRecentCleanups([]);
        }
      } catch (error) {
        console.error("Error fetching recent cleanups:", error);
        setRecentCleanups([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentCleanups();
  }, []);

  const getPhotoUri = (cleanup) => {
    // Prioritize photos in the specified order
    if (cleanup.photo_action_uri) return cleanup.photo_action_uri;
    if (cleanup.photo_volunteers_uri) return cleanup.photo_volunteers_uri;
    if (cleanup.photo_after_uri) return cleanup.photo_after_uri;
    if (cleanup.photo_before_uri) return cleanup.photo_before_uri;
    return null;
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <LoadingSpinner
          size="large"
          text="Loading recent cleanups..."
          color="#007bff"
        />
      </div>
    );
  }

  if (recentCleanups.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h3>Recent Cleanups</h3>
        <p>No cleanups in the last week. Be the first to log one!</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
        Last Week's Cleanups
      </h3>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {recentCleanups.map((cleanup, index) => {
          const photoUri = getPhotoUri(cleanup);

          return (
            <div
              key={cleanup.id || index}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "15px",
                marginBottom: "15px",
                backgroundColor: "#f9f9f9",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                display: "flex",
                alignItems: "center",
                gap: "15px"
              }}
            >
              {/* Photo Section */}
              <div style={{ flexShrink: 0 }}>
                {photoUri ? (
                  <img
                    src={photoUri}
                    alt={`Cleanup at ${cleanup.site_name || "site"}`}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "6px",
                      border: "1px solid #ddd"
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #ddd"
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        textAlign: "center"
                      }}
                    >
                      No Photo
                    </span>
                  </div>
                )}
              </div>

              {/* Content Section */}
              <div style={{ flex: 1 }}>
                <div>
                  <h4
                    style={{
                      margin: "0 0 8px 0",
                      color: "#333",
                      textAlign: "left"
                    }}
                  >
                    {cleanup.site_name || "Unknown Site"}
                  </h4>
                  <p
                    style={{
                      margin: "0",
                      color: "#666",
                      fontSize: "14px",
                      textAlign: "left"
                    }}
                  >
                    Date:{" "}
                    {cleanup.start_date
                      ? UtilDate.dateObjToString(cleanup.start_date)
                      : "Unknown"}
                  </p>
                </div>
                <div style={{ marginTop: "8px", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      fontWeight: "bold",
                      color: "#2c5aa0"
                    }}
                  >
                    {cleanup.total_time
                      ? `${cleanup.total_time} hours`
                      : "Time not specified"}
                  </p>
                  {cleanup.num_volunteers && (
                    <p style={{ margin: "0", fontSize: "12px", color: "#666" }}>
                      {cleanup.num_volunteers} volunteer
                      {cleanup.num_volunteers !== 1 ? "s" : ""}
                    </p>
                  )}

                  <hr />
                  {cleanup.notes && (
                    <p style={{ margin: "0", fontSize: "12px", color: "#666" }}>
                      {cleanup.notes}
                      {cleanup.notes !== 1 ? "s" : ""}
                    </p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentCleanupsFeed;
